import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import { BaasicButton } from 'core/components';
import { Content } from 'core/layouts';
import { observer } from "mobx-react";
import { PatientNewFlowInsuranceEditModalTemplate } from "themes/application/facility-order-new-flow-insurance/components";
import { Tooltip as ReactTooltip } from "react-tooltip";

const FacilityOrderPatientNewFlowInsuranceInsuranceEditTemplate = function ({ facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore, disabledOptions = false, disableForm }) {
    const {
        btPatient,
        loadingData,
        openAddCard,
        openEditCard,
        openDeleteCard,
        openChangeCard,
        showAddPrimary,
        showAddPrimaryInactive,
        showAddSecondary,
        showAddSecondaryInactive,
        showEditPrimary,
        showEditPrimaryInactive,
        showEditSecondary,
        showEditSecondaryInactive,
        showDeletePrimary,
        showDeletePrimaryInactive,
        showDeleteSecondary,
        showDeleteSecondaryInactive,
        showChangePrimary,
        showChangeSecondary,
        disabled,
        disableEdit
    } = facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore;

    return (
        <div style={{ minHeight: 225 }}>
            <Content loading={loadingData}>
                <ReactTooltip positionStrategy="fixed" id="registerTip" place="bottom" />
                <div className="modal__body">
                    <div>
                        <div className="card--sml card--outlined u-mar--bottom--sml--alt">
                            <div className={` ${btPatient && btPatient.primaryActivePayor ? 'u-mar--bottom--sml--alt' : 'u-mar--bottom--tny'}`}>
                                <h3 className='modal__header__title u-mar--bottom--sml'>Primary Insurance</h3>
                                {btPatient && !btPatient.primaryActivePayor && disableEdit &&
                                    <div className="status--sqare__wrapper w--max--300" data-tooltip-content={disableEdit ? "To change, add, or delete primary policy info, click on the orange 'Change Status' for this patient." : ""} data-tooltip-id={disableEdit ? "registerTip" : ""}>
                                        <BaasicButton
                                            className="btn btn--sml btn--card btn--card--dark"
                                            icon="u-icon u-icon--sml u-icon--add-lined u-mar--right--xtny"
                                            label="Add Policy"
                                            onClick={() => openAddCard(true, true)}
                                            disabled={disableEdit || disableForm}
                                        />
                                    </div>
                                }
                                {btPatient && !btPatient.primaryActivePayor && !disableEdit &&
                                    <BaasicButton
                                        className="btn btn--sml btn--card btn--card--dark"
                                        icon="u-icon u-icon--sml u-icon--add-lined u-mar--right--xtny"
                                        label="Add Policy"
                                        onClick={() => openAddCard(true, true)}
                                        disabled={disabled || disabledOptions || disableForm}
                                    />
                                }
                            </div>
                            {showAddPrimary &&
                                <InsuranceCard
                                    facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore={facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore}
                                    disableForm={disableForm}
                                />
                            }
                            <div>
                                <table className="table w--100 type--color--primary u-mar--top--tny">
                                    <tbody>
                                        {btPatient && btPatient.primaryActivePayor &&
                                            <tr>
                                                <td>{btPatient.primaryActivePayor.payorPolicyInfo.name}</td>
                                                <td className="type--right">{btPatient.primaryActivePayor.payorPolicyInfo.policyNumber}</td>
                                                <td className="type--right">{btPatient.primaryActivePayor.payorPolicyInfo.effectiveDate}</td>
                                                <td className="type--right">
                                                    {btPatient.primaryActivePayor &&
                                                        <div className="u-flex u-flex--default u-align--h--right u-flex--justify-end">
                                                            {disableEdit ?
                                                                <div className="status--sqare__wrapper " data-tooltip-content={disableEdit ? "To change, add, or delete primary policy info, click on the orange 'Change Status' for this patient." : ""} data-tooltip-id={disableEdit ? "registerTip" : ""}>
                                                                    <BaasicButton
                                                                        className="btn btn--icon btn--icon--square btn--icon--primary u-align--v--middle"
                                                                        icon="u-icon u-icon--xmed u-icon--reload--primary"
                                                                        label=""
                                                                        onClick={() => openChangeCard(true, true)}
                                                                        disabled={disableEdit || disableForm}
                                                                    />
                                                                </div> :
                                                                <BaasicButton
                                                                    className="btn btn--icon btn--icon--square btn--icon--primary u-align--v--middle"
                                                                    icon="u-icon u-icon--xmed u-icon--reload--primary"
                                                                    label=""
                                                                    onClick={() => openChangeCard(true, true)}
                                                                    disabled={disabled || disabledOptions || disableForm}
                                                                />}
                                                            <BaasicButton
                                                                className="btn btn--sml btn--icon btn--icon--square u-align--v--middle"
                                                                icon="u-icon u-icon--sml u-icon--edit-alt"
                                                                label=""
                                                                onClick={() => openEditCard(true, true)}
                                                                disabled={disabled || disableForm}
                                                            />
                                                            {disableEdit ?
                                                                <div className="status--sqare__wrapper" data-tooltip-content={disableEdit ? "To change, add, or delete primary policy info, click on the orange 'Change Status' for this patient." : ""} data-tooltip-id={disableEdit ? "registerTip" : ""}>
                                                                    <BaasicButton
                                                                        className="btn btn--icon btn--icon--square u-align--v--middle"
                                                                        icon="u-icon u-icon--sml u-icon--delete--primary"
                                                                        label="Delete"
                                                                        onlyIcon={true}
                                                                        onClick={() => openDeleteCard(true, true)}
                                                                        disabled={disableEdit || disableForm}
                                                                    ></BaasicButton>
                                                                </div> :
                                                                <BaasicButton
                                                                    className="btn btn--icon btn--icon--square u-align--v--middle"
                                                                    icon="u-icon u-icon--sml u-icon--delete--primary"
                                                                    label="Delete"
                                                                    onlyIcon={true}
                                                                    onClick={() => openDeleteCard(true, true)}
                                                                    disabled={disabled || disabledOptions || disableForm}
                                                                ></BaasicButton>}
                                                        </div>
                                                    }
                                                </td>
                                            </tr>
                                        }
                                        {showEditPrimary &&
                                            <EditInsuranceCard
                                                facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore={facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore}
                                                insuranceData={{ isPrimary: true, isActive: true }}
                                                disableForm={disableForm}
                                            />
                                        }
                                        {showDeletePrimary &&
                                            <DeleteInsuranceCard
                                                facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore={facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore}
                                                insuranceData={{ isPrimary: true, isActive: true, name: btPatient.primaryActivePayor.payorPolicyInfo.name }}
                                                disableForm={disableForm}
                                            />
                                        }
                                        {showChangePrimary &&
                                            <InsuranceCard
                                                facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore={facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore}
                                                disableForm={disableForm}
                                            />
                                        }
                                        {btPatient && (!btPatient.primaryActivePayor || btPatient.primaryActivePayor.payorPolicyInfo.name !== "Medicare") && btPatient.primaryInactivePayor &&
                                            <tr>
                                                <td>
                                                    <span>Medicare</span>
                                                    <div className="badge badge--tny badge--primary--light u-mar--left--xsml">Primary inactive</div>
                                                </td>
                                                <td className="type--right">{btPatient.primaryInactivePayor.payorPolicyInfo && btPatient.primaryInactivePayor.payorPolicyInfo.policyNumber}</td>
                                                <td className="type--right">{btPatient.primaryInactivePayor.payorPolicyInfo && btPatient.primaryInactivePayor.payorPolicyInfo.effectiveDate}</td>
                                                <td className="type--right">
                                                    {btPatient.primaryInactivePayor &&
                                                        <React.Fragment>
                                                            <BaasicButton
                                                                className="btn btn--sml btn--icon btn--icon--square u-align--v--middle"
                                                                icon="u-icon u-icon--sml u-icon--edit-alt"
                                                                label=""
                                                                onClick={() => openEditCard(true, false)}
                                                                disabled={disabled || disableForm}
                                                            />
                                                            <BaasicButton
                                                                className="btn btn--icon btn--icon--square u-align--v--middle"
                                                                icon="u-icon u-icon--sml u-icon--delete--primary"
                                                                label="Delete"
                                                                onlyIcon={true}
                                                                onClick={() => openDeleteCard(true, false)}
                                                                disabled={disabled || disableForm}
                                                            ></BaasicButton>
                                                        </React.Fragment>
                                                    }
                                                </td>
                                            </tr>
                                        }
                                        {showEditPrimaryInactive &&
                                            <EditInsuranceCard
                                                facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore={facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore}
                                                insuranceData={{ isPrimary: true, isActive: false }}
                                                disableForm={disableForm}
                                            />
                                        }
                                        {showDeletePrimaryInactive &&
                                            <DeleteInsuranceCard
                                                facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore={facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore}
                                                insuranceData={{ isPrimary: true, isActive: false, name: "Medicare" }}
                                                disableForm={disableForm}
                                            />
                                        }
                                    </tbody>
                                </table>
                            </div>
                            {btPatient && !(btPatient.primaryActivePayor && btPatient.primaryActivePayor.payorPolicyInfo.name === "Medicare") && !btPatient.primaryInactivePayor &&
                                <div>
                                    <button className='btn btn--base btn--card btn--card--light' onClick={() => openAddCard(true, false)} disabled={disableForm}>
                                        <i className="u-icon u-icon--sml u-icon--add-lined u-mar--right--xtny"></i>
                                        Add Inactive Medicare Policy
                                    </button>
                                </div>
                            }
                            {showAddPrimaryInactive &&
                                <InsuranceCard
                                    facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore={facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore}
                                    disableForm={disableForm}
                                />
                            }

                        </div>
                        <div className="card--sml card--outlined u-mar--bottom--sml--alt">
                            <div className={` ${btPatient && btPatient.secondaryActivePayor ? 'u-mar--bottom--sml--alt' : 'u-mar--bottom--tny'}`}>
                                <h3 className='modal__header__title u-mar--bottom--sml'>Secondary Insurance</h3>
                                {btPatient && !btPatient.secondaryActivePayor &&
                                    <BaasicButton
                                        className="btn btn--sml btn--card btn--card--dark"
                                        icon="u-icon u-icon--sml u-icon--add-lined u-mar--right--xtny"
                                        label="Add Policy"
                                        onClick={() => openAddCard(false, true)}
                                        disabled={disabled || disableForm}
                                    />
                                }
                            </div>
                            {showAddSecondary &&
                                <InsuranceCard
                                    facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore={facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore}
                                    disableForm={disableForm}
                                />
                            }
                            <div>
                                <table className="table w--100 type--color--primary">
                                    <tbody>
                                        {btPatient && btPatient.secondaryActivePayor &&
                                            <tr>
                                                <td>{btPatient.secondaryActivePayor.payorPolicyInfo.name}</td>
                                                <td className="type--right">{btPatient.secondaryActivePayor.payorPolicyInfo.policyNumber}</td>
                                                <td className="type--right">{btPatient.secondaryActivePayor.payorPolicyInfo.effectiveDate}</td>
                                                <td className="type--right">
                                                    {btPatient.secondaryActivePayor &&
                                                        <React.Fragment>
                                                            <BaasicButton
                                                                className="btn btn--icon btn--icon--square btn--icon--primary u-align--v--middle"
                                                                icon="u-icon u-icon--xmed u-icon--reload--primary"
                                                                label=""
                                                                onClick={() => openChangeCard(false, true)}
                                                                disabled={disabled || disableForm}
                                                            />
                                                            <BaasicButton
                                                                className="btn btn--sml btn--icon btn--icon--square u-align--v--middle"
                                                                icon="u-icon u-icon--sml u-icon--edit-alt"
                                                                label=""
                                                                onClick={() => openEditCard(false, true)}
                                                                disabled={disabled ||disableForm}
                                                            />
                                                            <BaasicButton
                                                                className="btn btn--icon btn--icon--square u-align--v--middle"
                                                                icon="u-icon u-icon--sml u-icon--delete--primary"
                                                                label="Delete"
                                                                onlyIcon={true}
                                                                onClick={() => openDeleteCard(false, true)}
                                                                disabled={disabled || disableForm}
                                                            ></BaasicButton>
                                                        </React.Fragment>
                                                    }
                                                </td>
                                            </tr>
                                        }
                                        {showEditSecondary &&
                                            <EditInsuranceCard
                                                facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore={facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore}
                                                insuranceData={{ isPrimary: false, isActive: true }}
                                                disableForm={disableForm}
                                            />
                                        }
                                        {showDeleteSecondary &&
                                            <DeleteInsuranceCard
                                                facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore={facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore}
                                                insuranceData={{ isPrimary: false, isActive: true, name: btPatient.secondaryActivePayor.payorPolicyInfo.name }}
                                                disableForm={disableForm}
                                            />
                                        }
                                        {showChangeSecondary &&
                                            <InsuranceCard
                                                facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore={facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore}
                                                disableForm={disableForm}
                                            />
                                        }
                                        {btPatient && (!btPatient.secondaryActivePayor || !btPatient.secondaryActivePayor.payorPolicyInfo.name.includes("Medicaid")) && btPatient.secondaryInactivePayor &&
                                            <tr>
                                                <td>
                                                    <span>{btPatient.secondaryInactivePayor.payorPolicyInfo.name}</span>
                                                    <div className="badge badge--tny badge--primary--light u-mar--left--xsml">Secondary inactive</div>
                                                </td>
                                                <td className="type--right">{btPatient.secondaryInactivePayor.payorPolicyInfo && btPatient.secondaryInactivePayor.payorPolicyInfo.policyNumber}</td>
                                                <td className="type--right">{btPatient.secondaryInactivePayor.payorPolicyInfo && btPatient.secondaryInactivePayor.payorPolicyInfo.effectiveDate}</td>
                                                <td className="type--right">
                                                    {btPatient.secondaryInactivePayor &&
                                                        <React.Fragment>
                                                            <BaasicButton
                                                                className="btn btn--sml btn--icon btn--icon--square u-align--v--middle"
                                                                icon="u-icon u-icon--sml u-icon--edit-alt"
                                                                label=""
                                                                onClick={() => openEditCard(false, false)}
                                                                disabled={disabled || disableForm}
                                                            />
                                                            <BaasicButton
                                                                className="btn btn--icon btn--icon--square u-align--v--middle"
                                                                icon="u-icon u-icon--sml u-icon--delete--primary"
                                                                label="Delete"
                                                                onlyIcon={true}
                                                                onClick={() => openDeleteCard(false, false)}
                                                                disabled={disabled || disableForm}
                                                            ></BaasicButton>
                                                        </React.Fragment>
                                                    }
                                                </td>
                                            </tr>
                                        }
                                        {showEditSecondaryInactive &&
                                            <EditInsuranceCard
                                                facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore={facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore}
                                                insuranceData={{ isPrimary: false, isActive: false }}
                                                disableForm={disableForm}
                                            />
                                        }
                                        {showDeleteSecondaryInactive &&
                                            <DeleteInsuranceCard
                                                facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore={facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore}
                                                insuranceData={{ isPrimary: false, isActive: false, name: "Medicaid" }}
                                                disableForm={disableForm}
                                            />
                                        }
                                    </tbody>
                                </table>
                            </div>
                            {btPatient && !(btPatient.secondaryActivePayor && btPatient.secondaryActivePayor.payorPolicyInfo.name.includes("Medicaid")) && !btPatient.secondaryInactivePayor &&
                                <div>
                                    <button className='btn btn--base btn--card btn--card--light' onClick={() => openAddCard(false, false)} disabled={disableForm}>
                                        <i className="u-icon u-icon--sml u-icon--add-lined u-mar--right--xtny"></i>
                                        Add Inactive Medicaid Policy
                                    </button>
                                </div>
                            }
                            {showAddSecondaryInactive &&
                                <InsuranceCard
                                    facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore={facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore}
                                    disableForm={disableForm}
                                />
                            }
                        </div>
                    </div>
                </div>
            </Content>
        </div>
    );
};

const InsuranceCard = observer(({ facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore, disableForm }) => {
    const {
        patientNewFlowInsuranceEditModalStore
    } = facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore;

    return (
        <tr>
            <td colSpan={"4"}>
                <div className="row u-mar--y--sml">
                    <PatientNewFlowInsuranceEditModalTemplate
                        patientNewFlowInsuranceEditModalStore={patientNewFlowInsuranceEditModalStore}
                        disableForm={disableForm}
                    />
                </div>
            </td>
        </tr>
    );
});

const EditInsuranceCard = observer(({ facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore, insuranceData, disableForm }) => {
    const {
        closeAll,
        confirmEditInsurancePolicy,
        disabled,
        showEditInsurancePolicy,
    } = facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore;

    return (
        <tr>
            <td colSpan={"4"}>
                {showEditInsurancePolicy ?
                    <InsuranceCard
                        facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore={facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore}
                        disableForm={disableForm}
                    />
                    :
                    <div className="u-mar--y--sml">
                        <h4 className='modal__header__title u-mar--bottom--sml'>You are about to edit this patient's active insurance</h4>
                        <span>This action should be done only if the policy number of the current active insurance is incorrect. If the patient has a new insurance policy, please add it as a new one.</span>
                        <div className="modal__footer">
                            <BaasicButton disabled={disabled || disableForm} className='btn btn--med btn--light' label="Cancel" onClick={() => closeAll()} />
                            <BaasicButton disabled={disabled || disableForm} className='btn btn--med btn--primary' label="Continue" onClick={() => confirmEditInsurancePolicy(insuranceData.isPrimary, insuranceData.isActive, insuranceData.name)} />
                        </div>
                    </div>
                }
            </td>
        </tr>
    );
});

const DeleteInsuranceCard = observer(({ facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore, insuranceData, disableForm }) => {
    const {
        closeAll,
        deleteInsurancePolicy,
        disabled
    } = facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore;

    return (
        <tr>
            <td colSpan={"4"}>
                <div className="u-mar--y--sml">
                    <h4 className='modal__header__title u-mar--bottom--sml'>Are you sure you want to Delete this Insurance Policy?</h4>
                    <span>This action should only be done if the policy was added in error. If there is a new policy that is replacing this one, exit this screen and click on the change icon to add the new policy.</span>
                    <div className="modal__footer">
                        <BaasicButton disabled={disabled || disableForm} className='btn btn--med btn--light' label="Cancel" onClick={() => closeAll()} />
                        <BaasicButton disabled={disabled || disableForm}  icon={disabled ? "u-icon u-icon--xmed u-icon--sync u-rotate--login" : 'u-display--none'} className='btn btn--med btn--primary' label="Confirm" onClick={() => deleteInsurancePolicy(insuranceData.isPrimary, insuranceData.isActive, insuranceData.name)} />
                    </div>
                </div>
            </td>
        </tr>
    );
});

InsuranceCard.propTypes = {
    facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore: PropTypes.object.isRequired,
    disableForm: PropTypes.bool
};

EditInsuranceCard.propTypes = {
    facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore: PropTypes.object.isRequired,
    insuranceData: PropTypes.object.isRequired,
    disableForm: PropTypes.bool
};

DeleteInsuranceCard.propTypes = {
    facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore: PropTypes.object.isRequired,
    insuranceData: PropTypes.object.isRequired,
    disableForm: PropTypes.bool
};

FacilityOrderPatientNewFlowInsuranceInsuranceEditTemplate.propTypes = {
    facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore: PropTypes.object.isRequired,
    disabledOptions: PropTypes.bool
};

export default defaultTemplate(FacilityOrderPatientNewFlowInsuranceInsuranceEditTemplate);